import * as React from 'react';
import * as style from './Overlay.css';
import { clsx } from 'clsx';

interface IOverlayProps {
  children: React.ReactNode;
  onClose(): void;
  isOpen: boolean;
  outside?: boolean;
  zIndex?: number;
}

/**
 * Затеняющая подложка
 */
export const Overlay: React.FC<IOverlayProps> = ({ children, zIndex, outside, onClose, isOpen }): JSX.Element => {
  const onClick = React.useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (outside && e.currentTarget === e.target) {
        onClose();
      }
    },
    [onClose, outside],
  );

  return (
    <div className={clsx(style['overlay'], isOpen && style['open'])} style={{ zIndex }} onClick={onClick}>
      {children}
    </div>
  );
};
